import React from 'react'
import { checkTranslation } from '../../utils/useful'
import TLink from '../TLink'

class HomeDashboard extends React.Component {

    state = {
        open: false
    }



    render() {

        let data = this.props.data
        let link
        if (!data.pageHome) {

            link = '/' + data.key
        } else {

            link = '/' + (data.pageHome) + '/' + data.key
        }
        return (
            <div className="w-100 flexc h-100">
                <TLink className="m-0 p-0 w-100 h-100 flexc" to={link}>

                    <div className="my-3 px-3  cover-img-container p-0 flexcc">
                        <div className="m-0 p-0 w-100 h-100 flexcc" to={link}>
                            <img className="cover-img m-0 p-0" src={data.image} alt={data.title} style={{ width: 50, height: 50, marginTop: 20 }} />
                        </div>
                    </div>



                    <div className="mx-3 service-box-content ">
                        <div to={link}><p className="" style={{ fontWeight: 500, fontSize: 18 }}>{checkTranslation(data.title)}</p></div>
                        <div to={link}><p className="service-box-desc text-smaller">{checkTranslation(data.description)}</p></div>
                    </div>
                    {/* 
                <div className="flexcb service-box-actions  mx-3 pb-3 pt-3">
                    <TLink to={link} className="py-1 px-3 preview-but">
                        <p className="text-smaller">Open</p>
                    </TLink>
                    
                </div> */}

                </TLink>

            </div>
        )
    }
}

export default HomeDashboard
